import { addToast } from "@caprikorn/dynamo-ui";
import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@/AppQueryClient";
import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

const postPerimeterExport = () => apiEcmsHttp.post("/perimeter-export", null);

export const usePostPerimeterExport = (supportEmail: string) => {
  const { currentGroup } = useGroupReferences();
  const { t } = useCustomTranslation("main");

  return useMutation({
    mutationKey: [QUERY_KEYS.PERIMETER_EXPORT_GENERATION, currentGroup],
    mutationFn: postPerimeterExport,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.PERIMETER_EXPORT, currentGroup],
      });
      addToast({
        variant: "success",
        title: t("documents.toast.extractGenerationSuccess.title"),
        description: t("documents.toast.extractGenerationSuccess.description"),
      });
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("documents.toast.extractGenerationError.title"),
        description: t("documents.toast.extractGenerationError.description", {
          supportEmail,
        }),
      });
    },
    retry: false,
  });
};
